//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ThemeSwitch',
  methods: {
    switchTheme () {
      this.$store.dispatch('switchThemeMode')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ThemeSwitch/ThemeSwitch.vue